import React from 'react';

// Discord server and bots privacy policy, routed at /discord/policy. Same layout as Pages/Policy.js.
const styles = {
  page: { maxWidth: 860, margin: '40px auto', padding: '0 16px', lineHeight: 1.7, fontSize: 16 },
  h1: { fontSize: 28, lineHeight: 1.25, margin: '0 0 8px 0' },
  meta: { fontSize: 13, color: '#6b7280', margin: '0 0 24px 0' },
  h2: { fontSize: 20, margin: '28px 0 8px 0' },
  ul: { paddingLeft: 22, margin: '8px 0 16px 0' },
};

class DiscordPolicyPage extends React.Component {
  render() {
    return (
      <div style={styles.page}>
        <h1 style={styles.h1}>DISCORD - PRIVACY POLICY</h1>
        <p style={styles.meta}><strong><em>Last updated: October 9, 2026</em></strong></p>
        <p><strong>Piece of Cake Studios, S.A.S. (Paris, France)</strong></p>

        <p>
          This policy explains how Piece of Cake Studios ("we", "us") processes information on our official Discord
          server and through the bots we run on it. Discord itself processes your data under its
          own <a href="https://discord.com/privacy">Privacy Policy</a>. For our games, see
          our <a href="/policy">game privacy policy</a>.
        </p>

        <h2 style={styles.h2}>1. Our bots</h2>
        <ul style={styles.ul}>
          <li>
            <strong>Poke</strong> - our community assistant. Poke gathers bug reports from our game channels and from
            inside our games into a dedicated bug-report channel, follows them up, and answers our team's questions in
            internal channels.
          </li>
          <li>
            <strong>Hermione</strong> and <strong>Hercule</strong> - assistants used only by our team, in internal staff
            channels. They do not process messages from community members.
          </li>
        </ul>

        <h2 style={styles.h2}>2. What we process</h2>
        <ul style={styles.ul}>
          <li>Your Discord user ID, username, display name and roles on our server.</li>
          <li>The messages you post in channels where our bots are present, and the attachments you share there.</li>
          <li>
            For bug reports only: the game you are playing and its platform, read once from your Discord activity when
            you report a bug, if you share your activity on Discord.
          </li>
          <li>
            Bug reports you send from inside our games: your description, screenshots, and technical information about
            your device and game version.
          </li>
        </ul>

        <h2 style={styles.h2}>3. Why we process it</h2>
        <ul style={styles.ul}>
          <li>To collect, organise and follow up on bug reports, and to tell you when a bug you reported is fixed.</li>
          <li>To guide new testers and to limit some bot actions to our team.</li>
          <li>To help our team with its work in internal channels.</li>
        </ul>
        <p>
          We rely on our legitimate interest in supporting our players, fixing our games and running our community
          (Article 6(1)(f) GDPR).
        </p>

        <h2 style={styles.h2}>4. Automated processing and AI</h2>
        <p>
          Our bots use automated tools, including AI models, to understand messages, summarise bug reports and write
          replies. Poke uses only models we run on our own hardware: your messages are not sent to any third-party AI
          service. Our team assistants may use AI service providers acting on our behalf, which may process data outside
          the EU under appropriate safeguards. We do not use your messages to train AI models, and no decision with legal
          or similarly significant effects is made about you by automated means.
        </p>

        <h2 style={styles.h2}>5. What we keep</h2>
        <ul style={styles.ul}>
          <li>
            Poke keeps no copy of your Discord data. Bug reports exist as messages in our Discord bug-report channel,
            where you can see them.
          </li>
          <li>
            Your activity is read once, when you report a bug. You confirm, correct or remove the detected values on
            your report. We do not store your online status or activity history.
          </li>
          <li>
            Bug reports sent from inside our games are posted to the bug-report channel without information that
            identifies you. The report itself is handled under the privacy policy of the game you sent it from.
          </li>
          <li>
            Conversations between our team and our team assistants are kept as internal work records, for as long as
            they are useful to our team.
          </li>
        </ul>

        <h2 style={styles.h2}>6. Sharing</h2>
        <p>
          We do not sell this data or use it for advertising. We share it only with service providers acting on our
          behalf, and with authorities where the law requires it.
        </p>

        <h2 style={styles.h2}>7. Your choices and rights</h2>
        <ul style={styles.ul}>
          <li>Turn off activity sharing in your Discord privacy settings: our bots then cannot read it.</li>
          <li>Remove the detected game and platform from your bug report with the buttons on it.</li>
          <li>
            Ask us to remove a bug report about you, or exercise your rights of access, correction, deletion and
            objection, by writing to <a href="mailto:contact@pieceofcake-studios.com">contact@pieceofcake-studios.com</a> with
            your Discord username.
          </li>
          <li>
            Lodge a complaint with the French data protection authority, the CNIL
            (<a href="https://www.cnil.fr">www.cnil.fr</a>).
          </li>
        </ul>

        <h2 style={styles.h2}>8. Changes</h2>
        <p>We may update this policy. The date at the top shows the current version.</p>

        <h2 style={styles.h2}>9. Contact</h2>
        <p>
          Piece of Cake Studios, S.A.S., Paris, France
          - <a href="mailto:contact@pieceofcake-studios.com">contact@pieceofcake-studios.com</a>
        </p>
      </div>
    );
  }
}

export default DiscordPolicyPage;
